import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';


import {
  EXPERIENCE_JOB_CHANGE,
  EXPERIENCE_JOB_BLURRED,
  EXPERIENCE_JOB_FOCUSED,
  EXPERIENCE_JOB_GET_SUGGESTIONS,
  experienceJobSetVisualization,
  experienceJobSet,
  experienceJobSetFocus,
  experienceJobSuggestionsSet, experienceJobSuggestionsError
} from 'src/app/redux/actions/registration/experience/experienceJob';
import suggestionApi from 'src/app/api/suggestionsApi';
import prepareSuggestions from 'src/app/api/prepareSuggestions';


function* experienceJobFocus() {
  yield put(experienceJobSetFocus(true));
}

function* experienceJobBlur({ payload }) {
  const { markedAsWrong, validationMessage } = payload;

  yield put(experienceJobSetFocus(false));

  if (!markedAsWrong) {
    yield put(experienceJobSetVisualization(!!validationMessage));
  }
}

function getJobSuggestions(suggestionsRequest, modifyResponse) {
  return function* getJobSuggestionsGenerator({ payload }) {
    const { query } = payload;

    yield delay(500);

    const getSuggestionWithDispatchers = yield suggestionsRequest(query)
      .then(function* onSuccess({ data }) {
        return yield put(experienceJobSuggestionsSet(modifyResponse(data.jobTitles)));
      })
      .catch(function* onError() { yield put(experienceJobSuggestionsError()); });

    yield call(() => getSuggestionWithDispatchers);
  };
}

function* experienceJobChange({ payload }) {
  const { value, markedAsWrong, apiError, validationMessage } = payload;

  yield put(experienceJobSet(value));

  if (markedAsWrong || apiError) {
    yield put(experienceJobSetVisualization(!!validationMessage));
  }
}


export { experienceJobFocus, experienceJobBlur, experienceJobChange };

export default [
  takeEvery(EXPERIENCE_JOB_CHANGE, experienceJobChange),
  takeEvery(EXPERIENCE_JOB_FOCUSED, experienceJobFocus),
  takeEvery(EXPERIENCE_JOB_BLURRED, experienceJobBlur),
  takeLatest(EXPERIENCE_JOB_GET_SUGGESTIONS, getJobSuggestions(suggestionApi.getJobSuggestions, prepareSuggestions))
];
